"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../../../common/js/BaseComponent");
/**
 * AppointmentAccordion Component
 * Gère l'animation et l'état de l'accordéon pour les rendez-vous avec plusieurs devis
 */
var AppointmentAccordion = /** @class */ (function (_super) {
    __extends(AppointmentAccordion, _super);
    function AppointmentAccordion($view) {
        var _this = _super.call(this, $view) || this;
        _this.chevronToggles = _this.$view[0].querySelectorAll('.chevron-toggle');
        _this.initListeners();
        return _this;
    }
    AppointmentAccordion.prototype.initListeners = function () {
        this.chevronToggles.forEach(function (toggle) {
            // Gérer le clic sur le chevron
            toggle.addEventListener('click', function (e) {
                var currentState = toggle.getAttribute('aria-expanded');
                var newState = currentState === 'true' ? 'false' : 'true';
                toggle.setAttribute('aria-expanded', newState);
            });
            // Synchroniser avec les événements Bootstrap collapse
            var targetId = toggle.getAttribute('data-bs-target');
            if (targetId) {
                var targetElement = document.querySelector(targetId);
                if (targetElement) {
                    targetElement.addEventListener('shown.bs.collapse', function () {
                        toggle.setAttribute('aria-expanded', 'true');
                    });
                    targetElement.addEventListener('hidden.bs.collapse', function () {
                        toggle.setAttribute('aria-expanded', 'false');
                    });
                }
            }
        });
    };
    return AppointmentAccordion;
}(BaseComponent_1.default));
exports.default = AppointmentAccordion;
